const SessionDoneDecoration = () => (
    <svg
        width="300"
        height="160"
        viewBox="0 0 337 204"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            width="32.677"
            height="8.23791"
            rx="4.11896"
            transform="matrix(-0.720625 -0.693325 -0.693325 0.720625 41.034 155.739)"
            fill="#E1BEE7"
        />
        <rect
            width="32.6771"
            height="8.23791"
            rx="4.11896"
            transform="matrix(0.720625 0.693325 0.693325 -0.720625 21.4927 128.706)"
            fill="#E1BEE7"
        />
        <path
            d="M25.8854 111.43C25.2982 112.578 25.7494 114.001 26.9647 114.431C28.4022 114.94 29.9029 115.261 31.4294 115.384C33.7333 115.569 36.0511 115.298 38.2505 114.588C40.4501 113.877 42.4882 112.74 44.2484 111.242C46.0086 109.743 47.4566 107.913 48.5095 105.855C49.5622 103.797 50.1993 101.552 50.3845 99.2485C50.5697 96.9444 50.2996 94.6261 49.589 92.4265C48.8784 90.2271 47.7417 88.1891 46.2436 86.4291C45.251 85.2629 44.1125 84.2338 42.8587 83.3658C41.7986 82.632 40.3808 83.0985 39.7936 84.2463L38.2448 87.2734C37.6581 88.4202 38.1357 89.8078 39.1148 90.645C39.5155 90.9875 39.8893 91.3619 40.2325 91.7651C41.0836 92.7651 41.7294 93.9232 42.1331 95.1727C42.5368 96.4224 42.6907 97.7393 42.5855 99.0483C42.4803 100.357 42.1178 101.633 41.5196 102.802C40.9214 103.971 40.0992 105.011 39.0992 105.863C38.0991 106.714 36.9411 107.359 35.6915 107.763C34.4419 108.167 33.1249 108.321 31.8159 108.216C31.2882 108.173 30.7658 108.089 30.2536 107.964C29.0019 107.66 27.597 108.085 27.0103 109.232L25.8854 111.43Z"
            fill="#B2EBF2"
        />
        <path
            d="M97.2677 162.074C98.4317 161.52 98.9382 160.116 98.2347 159.035C97.4027 157.757 96.4062 156.59 95.2687 155.565C93.5519 154.018 91.5469 152.823 89.3686 152.051C87.1901 151.278 84.8802 150.942 82.5719 151.062C80.2635 151.182 78.0009 151.755 75.9141 152.75C73.8274 153.744 71.957 155.139 70.4096 156.856C68.862 158.573 67.6672 160.578 66.8945 162.756C66.1219 164.935 65.7858 167.244 65.9055 169.552C65.9849 171.081 66.2634 172.591 66.7314 174.042C67.1271 175.269 68.5364 175.76 69.7004 175.206L72.7701 173.744C73.9331 173.19 74.3971 171.797 74.1281 170.538C74.018 170.022 73.9487 169.498 73.9212 168.969C73.8532 167.658 74.0444 166.346 74.4833 165.108C74.9223 163.87 75.6007 162.731 76.4798 161.756C77.359 160.78 78.4219 159.987 79.6074 159.422C80.793 158.857 82.0787 158.532 83.3902 158.464C84.7017 158.396 86.0144 158.587 87.2522 159.026C88.4898 159.465 89.6291 160.143 90.6046 161.022C90.9978 161.376 91.3613 161.761 91.6922 162.171C92.5009 163.174 93.8743 163.691 95.0373 163.137L97.2677 162.074Z"
            fill="#B2EBF2"
        />
        <path
            d="M123.632 50.9613C123.045 52.1091 123.496 53.5319 124.712 53.9622C126.149 54.4712 127.65 54.7924 129.176 54.9151C131.48 55.1002 133.798 54.8297 135.998 54.1192C138.197 53.4085 140.235 52.2711 141.995 50.7729C143.756 49.2746 145.204 47.444 146.256 45.3861C147.309 43.3284 147.946 41.0837 148.131 38.7797C148.317 36.4757 148.047 34.1573 147.336 31.9578C146.625 29.7584 145.489 27.7204 143.991 25.9603C142.998 24.7942 141.859 23.765 140.606 22.8971C139.546 22.1632 138.128 22.6297 137.541 23.7775L135.992 26.8045C135.405 27.9514 135.883 29.3389 136.862 30.1757C137.263 30.5181 137.637 30.8923 137.98 31.2955C138.831 32.2954 139.477 33.4536 139.881 34.7031C140.284 35.9528 140.438 37.2704 140.333 38.5795C140.227 39.8886 139.866 41.1644 139.267 42.3336C138.669 43.5027 137.846 44.5425 136.846 45.3937C135.846 46.2449 134.688 46.8907 133.438 47.2944C132.189 47.6981 130.872 47.852 129.563 47.7468C129.035 47.7043 128.513 47.6202 128.001 47.4958C126.749 47.1915 125.344 47.616 124.757 48.7629L123.632 50.9613Z"
            fill="#FFCCBC"
        />
        <path
            d="M139.217 171.026C138.63 172.174 139.081 173.597 140.296 174.027C141.734 174.536 143.235 174.857 144.761 174.98C147.065 175.165 149.383 174.895 151.582 174.184C153.782 173.473 155.82 172.336 157.58 170.838C159.34 169.34 160.788 167.509 161.841 165.451C162.894 163.393 163.531 161.149 163.716 158.845C163.901 156.541 163.631 154.222 162.921 152.023C162.21 149.823 161.073 147.785 159.575 146.025C158.583 144.859 157.444 143.83 156.19 142.962C155.13 142.228 153.712 142.695 153.125 143.842L151.576 146.87C150.99 148.016 151.467 149.404 152.446 150.241C152.847 150.584 153.221 150.958 153.564 151.361C154.415 152.361 155.061 153.519 155.465 154.769C155.868 156.019 156.022 157.335 155.917 158.644C155.812 159.954 155.449 161.229 154.851 162.398C154.253 163.567 153.431 164.607 152.431 165.459C151.431 166.31 150.273 166.956 149.023 167.359C147.774 167.763 146.456 167.917 145.148 167.812C144.62 167.769 144.097 167.685 143.585 167.561C142.333 167.256 140.929 167.681 140.342 168.828L139.217 171.026Z"
            fill="#FFCCBC"
        />
        <rect
            x="27.4434"
            y="74.7695"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(-121.25 27.4434 74.7695)"
            fill="#FFCCBC"
        />
        <rect
            x="6.41498"
            y="63.5999"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(-31.2499 6.41498 63.5999)"
            fill="#FFCCBC"
        />
        <rect
            x="106.878"
            y="89.2222"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(-115.532 106.878 89.2222)"
            fill="#E1BEE7"
        />
        <rect
            x="87.0666"
            y="76.0129"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(-25.5324 87.0666 76.0129)"
            fill="#E1BEE7"
        />
        <rect
            x="85.1895"
            y="106.941"
            width="32.8239"
            height="8.27492"
            rx="4.13746"
            transform="rotate(-142.439 85.1895 106.941)"
            fill="#FFE0B2"
        />
        <circle
            cx="3.87126"
            cy="3.87126"
            r="3.87126"
            transform="matrix(0.787632 0.616146 0.616146 -0.787632 77.6346 136.051)"
            fill="#FFCCBC"
        />
        <circle
            cx="3.87126"
            cy="3.87126"
            r="3.87126"
            transform="matrix(0.787632 0.616146 0.616146 -0.787632 59.4473 121.823)"
            fill="#FFCCBC"
        />
        <rect
            x="87.4407"
            y="117.775"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(128.035 87.4407 117.775)"
            fill="#FFCCBC"
        />
        <circle
            cx="3.87126"
            cy="3.87126"
            r="3.87126"
            transform="matrix(0.787632 0.616146 0.616146 -0.787632 101.448 30.3237)"
            fill="#FFE0B2"
        />
        <circle
            cx="3.87126"
            cy="3.87126"
            r="3.87126"
            transform="matrix(0.787632 0.616146 0.616146 -0.787632 83.261 16.0957)"
            fill="#FFE0B2"
        />
        <rect
            x="111.254"
            y="12.0481"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(128.035 111.254 12.0481)"
            fill="#FFE0B2"
        />
        <circle
            cx="3.87126"
            cy="3.87126"
            r="3.87126"
            transform="matrix(0.949569 -0.313557 -0.313557 -0.949569 150.592 82.2021)"
            fill="#FFE0B2"
        />
        <circle
            cx="3.87126"
            cy="3.87126"
            r="3.87126"
            transform="matrix(0.949569 -0.313557 -0.313557 -0.949569 128.666 89.4426)"
            fill="#FFE0B2"
        />
        <rect
            x="140.826"
            y="63.9062"
            width="32.8239"
            height="8.27493"
            rx="4.13747"
            transform="rotate(71.7263 140.826 63.9062)"
            fill="#FFE0B2"
        />
        <path
            d="M135.359 113.852C136.599 113.501 137.334 112.201 136.822 111.018C136.216 109.619 135.429 108.301 134.479 107.1C133.046 105.286 131.27 103.773 129.252 102.646C127.234 101.519 125.013 100.801 122.717 100.532C120.422 100.263 118.095 100.449 115.872 101.079C113.648 101.709 111.569 102.771 109.756 104.204C107.942 105.638 106.428 107.414 105.301 109.432C104.174 111.45 103.456 113.67 103.187 115.966C103.009 117.487 103.03 119.021 103.248 120.531C103.433 121.807 104.74 122.527 105.98 122.176L109.252 121.249C110.491 120.898 111.182 119.603 111.128 118.316C111.106 117.789 111.126 117.261 111.188 116.735C111.341 115.431 111.749 114.169 112.389 113.023C113.03 111.876 113.889 110.867 114.919 110.052C115.95 109.238 117.13 108.634 118.394 108.276C119.658 107.918 120.979 107.813 122.284 107.966C123.588 108.119 124.85 108.527 125.996 109.167C127.143 109.808 128.152 110.667 128.966 111.698C129.295 112.113 129.589 112.553 129.846 113.013C130.476 114.137 131.743 114.876 132.983 114.525L135.359 113.852Z"
            fill="#B2EBF2"
        />
        <rect
            x="175.492"
            y="119.589"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(156.601 175.492 119.589)"
            fill="#E1BEE7"
        />
        <rect
            x="42.1534"
            y="41.3694"
            width="32.8239"
            height="8.27492"
            rx="4.13746"
            transform="rotate(-137.953 42.1534 41.3694)"
            fill="#FFCCBC"
        />
        <rect
            x="111.966"
            y="158.769"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(-69.3794 111.966 158.769)"
            fill="#FFE0B2"
        />
        <rect
            x="107.769"
            y="135.331"
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="rotate(20.6206 107.769 135.331)"
            fill="#FFE0B2"
        />
        <rect
            width="32.677"
            height="8.23791"
            rx="4.11896"
            transform="matrix(0.333413 -0.942781 -0.942781 -0.333413 58.8332 67.1824)"
            fill="#B2EBF2"
        />
        <rect
            width="32.677"
            height="8.23791"
            rx="4.11895"
            transform="matrix(-0.333413 0.942781 0.942781 0.333413 75.3708 38.2139)"
            fill="#B2EBF2"
        />
        <rect
            width="32.6771"
            height="8.23791"
            rx="4.11896"
            transform="matrix(-0.452365 -0.891833 -0.891833 0.452365 182.106 77.5305)"
            fill="#B2EBF2"
        />
        <rect
            width="32.6771"
            height="8.23792"
            rx="4.11896"
            transform="matrix(0.452365 0.891833 0.891833 -0.452365 172.547 45.573)"
            fill="#B2EBF2"
        />
        <path
            d="M246.561 163.074C245.397 162.52 244.891 161.116 245.594 160.035C246.426 158.757 247.423 157.59 248.56 156.565C250.277 155.018 252.282 153.823 254.46 153.051C256.639 152.278 258.949 151.942 261.257 152.062C263.565 152.182 265.828 152.755 267.915 153.75C270.001 154.744 271.872 156.139 273.419 157.856C274.967 159.573 276.162 161.578 276.934 163.756C277.707 165.935 278.043 168.244 277.923 170.552C277.844 172.081 277.565 173.591 277.097 175.042C276.702 176.269 275.292 176.76 274.128 176.206L271.059 174.744C269.896 174.19 269.432 172.797 269.701 171.538C269.811 171.022 269.88 170.498 269.908 169.969C269.976 168.658 269.784 167.346 269.345 166.108C268.906 164.87 268.228 163.731 267.349 162.756C266.47 161.78 265.407 160.987 264.221 160.422C263.036 159.857 261.75 159.532 260.439 159.464C259.127 159.396 257.814 159.587 256.577 160.026C255.339 160.465 254.2 161.143 253.224 162.022C252.831 162.376 252.467 162.761 252.137 163.171C251.328 164.174 249.954 164.691 248.791 164.137L246.561 163.074Z"
            fill="#B2EBF2"
        />
        <path
            d="M220.196 51.9613C220.784 53.1091 220.332 54.5319 219.117 54.9622C217.68 55.4712 216.179 55.7924 214.652 55.9151C212.349 56.1002 210.031 55.8297 207.831 55.1192C205.632 54.4085 203.594 53.2711 201.833 51.7729C200.073 50.2746 198.625 48.444 197.572 46.3861C196.52 44.3284 195.883 42.0837 195.697 39.7797C195.512 37.4757 195.782 35.1573 196.493 32.9578C197.203 30.7584 198.34 28.7204 199.838 26.9603C200.831 25.7942 201.969 24.765 203.223 23.8971C204.283 23.1632 205.701 23.6297 206.288 24.7775L207.837 27.8045C208.424 28.9514 207.946 30.3389 206.967 31.1757C206.566 31.5181 206.192 31.8923 205.849 32.2955C204.998 33.2954 204.352 34.4536 203.948 35.7031C203.544 36.9528 203.391 38.2704 203.496 39.5795C203.602 40.8886 203.963 42.1644 204.561 43.3336C205.16 44.5027 205.983 45.5425 206.983 46.3937C207.983 47.2449 209.141 47.8907 210.39 48.2944C211.64 48.6981 212.957 48.852 214.266 48.7468C214.794 48.7043 215.316 48.6202 215.828 48.4958C217.08 48.1915 218.485 48.616 219.072 49.7629L220.196 51.9613Z"
            fill="#FFCCBC"
        />
        <rect
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="matrix(0.431022 -0.902341 -0.902341 -0.431022 236.951 90.2222)"
            fill="#E1BEE7"
        />
        <rect
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="matrix(-0.902341 -0.431022 -0.431022 0.902341 256.762 77.0129)"
            fill="#E1BEE7"
        />
        <rect
            width="32.8239"
            height="8.27492"
            rx="4.13746"
            transform="matrix(0.7927 -0.609612 -0.609612 -0.7927 258.639 107.941)"
            fill="#FFE0B2"
        />
        <circle
            cx="260.76"
            cy="136.386"
            r="3.87126"
            transform="rotate(141.965 260.76 136.386)"
            fill="#FFCCBC"
        />
        <circle
            cx="278.947"
            cy="122.159"
            r="3.87126"
            transform="rotate(141.965 278.947 122.159)"
            fill="#FFCCBC"
        />
        <rect
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="matrix(0.616146 0.787632 0.787632 -0.616146 256.388 118.775)"
            fill="#FFCCBC"
        />
        <circle
            cx="236.947"
            cy="30.6599"
            r="3.87126"
            transform="rotate(141.965 236.947 30.6599)"
            fill="#FFE0B2"
        />
        <circle
            cx="255.133"
            cy="16.4318"
            r="3.87126"
            transform="rotate(141.965 255.133 16.4318)"
            fill="#FFE0B2"
        />
        <rect
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="matrix(0.616146 0.787632 0.787632 -0.616146 232.575 13.0481)"
            fill="#FFE0B2"
        />
        <path
            d="M225.114 112.534C223.874 112.183 223.139 110.884 223.651 109.7C224.257 108.301 225.044 106.983 225.994 105.782C227.427 103.968 229.203 102.455 231.221 101.328C233.239 100.201 235.46 99.483 237.756 99.2141C240.051 98.9452 242.377 99.1311 244.601 99.7611C246.825 100.391 248.904 101.453 250.717 102.887C252.531 104.32 254.045 106.096 255.172 108.114C256.299 110.132 257.017 112.352 257.286 114.648C257.464 116.169 257.443 117.704 257.225 119.213C257.04 120.489 255.733 121.21 254.493 120.858L251.221 119.931C249.982 119.58 249.291 118.285 249.345 116.998C249.367 116.472 249.347 115.943 249.285 115.417C249.132 114.113 248.724 112.851 248.084 111.705C247.443 110.558 246.584 109.549 245.554 108.735C244.523 107.92 243.343 107.316 242.079 106.958C240.815 106.6 239.493 106.495 238.189 106.648C236.885 106.801 235.623 107.209 234.477 107.849C233.33 108.49 232.321 109.349 231.507 110.38C231.178 110.795 230.884 111.235 230.627 111.695C229.997 112.819 228.73 113.559 227.49 113.207L225.114 112.534Z"
            fill="#B2EBF2"
        />
        <rect
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="matrix(-0.352178 -0.935933 -0.935933 0.352178 231.862 159.769)"
            fill="#FFE0B2"
        />
        <rect
            width="32.8239"
            height="8.27493"
            rx="4.13746"
            transform="matrix(-0.935933 0.352178 0.352178 0.935933 236.06 136.331)"
            fill="#FFE0B2"
        />
        <rect
            x="284.996"
            y="68.1824"
            width="32.677"
            height="8.23791"
            rx="4.11896"
            transform="rotate(-109.476 284.996 68.1824)"
            fill="#B2EBF2"
        />
        <rect
            x="268.458"
            y="39.2139"
            width="32.677"
            height="8.23791"
            rx="4.11895"
            transform="rotate(70.5239 268.458 39.2139)"
            fill="#B2EBF2"
        />
        <rect
            width="77.9847"
            height="107.518"
            rx="38.9924"
            transform="matrix(-0.986614 0.163075 0.163075 0.986614 264.811 13.5471)"
            fill="#8DCAFF"
        />
        <path
            d="M250.915 68.1077C250.086 64.1732 244.486 63.4656 241.644 66.3108C237.401 70.5597 232.836 71.1702 227.19 69.0473C222.943 67.4507 217.889 70.7572 218.824 75.1965C219.677 79.245 222.528 82.7078 226.551 83.672C234.278 85.5236 240.014 84.4679 246.987 79.383C250.478 76.8367 251.806 72.3363 250.915 68.1077Z"
            fill="black"
        />
        <path
            d="M227.178 79.7633C225.094 79.6923 223.131 79.9592 221.435 80.4802C222.769 82.0282 224.521 83.1791 226.582 83.673C230.562 84.6268 234.013 84.8057 237.378 84.0634C235.697 81.678 231.788 79.9204 227.178 79.7633Z"
            fill="#F48FB1"
        />
        <rect
            width="11.4089"
            height="69.753"
            transform="matrix(-0.986614 0.163075 0.163075 0.986614 261.704 108.985)"
            fill="#8DCAFF"
        />
        <path
            d="M278.931 182.22C277.998 176.572 272.662 172.75 267.014 173.684L266.238 173.812C260.59 174.746 256.768 180.081 257.701 185.729C257.906 186.967 259.075 187.804 260.312 187.6L277.061 184.831C278.299 184.627 279.136 183.458 278.931 182.22Z"
            fill="#8DCAFF"
        />
        <rect
            width="11.4089"
            height="69.753"
            transform="matrix(-0.986614 0.163075 0.163075 0.986614 234.276 113.519)"
            fill="#8DCAFF"
        />
        <path
            d="M251.503 186.754C250.57 181.106 245.234 177.284 239.586 178.217L238.809 178.346C233.161 179.279 229.34 184.615 230.273 190.263C230.478 191.5 231.647 192.338 232.884 192.133L249.633 189.365C250.87 189.16 251.708 187.991 251.503 186.754Z"
            fill="#8DCAFF"
        />
        <path
            d="M307.945 42.7299C309.223 40.3359 308.652 37.3729 306.578 35.6228C303.716 33.2083 299.351 34.1327 297.644 37.465C288.094 56.1057 280.46 66.734 267.233 75.9067C264.042 78.1192 263.63 82.8005 266.597 85.3044C268.45 86.8681 271.111 87.0772 273.132 85.7364C290.665 74.1007 297.621 62.0703 307.945 42.7299Z"
            fill="#8DCAFF"
        />
        <path
            d="M151.497 75.027C149.192 73.5939 148.204 70.7428 149.124 68.1897C150.393 64.6671 154.635 63.2827 157.781 65.3133C175.378 76.6722 187.305 82.0536 203.348 83.3748C207.217 83.6935 209.917 87.5401 208.601 91.1929C207.779 93.4743 205.581 94.9869 203.16 94.8372C182.157 93.5385 170.114 86.6044 151.497 75.027Z"
            fill="#8DCAFF"
        />
        <rect
            width="4.40469"
            height="14.9471"
            rx="2.20235"
            transform="matrix(-0.986614 0.163075 0.163075 0.986614 237.821 45.5271)"
            fill="black"
        />
        <rect
            width="4.40469"
            height="14.9471"
            rx="2.20235"
            transform="matrix(-0.986614 0.163075 0.163075 0.986614 228.346 47.093)"
            fill="black"
        />
        <path
            d="M193.789 73.3148L191.766 61.0748C188.095 38.8636 203.125 17.8816 225.336 14.2104V14.2104C247.547 10.5391 268.529 25.5688 272.2 47.78L274.224 60.02"
            stroke="black"
            strokeWidth="2.95382"
        />
        <path
            d="M280.812 47.3283C280.546 45.7188 279.026 44.6297 277.416 44.8958L270.422 46.0518L274.174 68.7507C274.336 69.7344 275.266 70.4 276.249 70.2374L281.462 69.3757C283.072 69.1097 284.161 67.5892 283.895 65.9797L280.812 47.3283Z"
            fill="black"
        />
        <path
            d="M186.619 82.0581C186.885 83.6676 188.405 84.7567 190.015 84.4907L195.157 83.6408C196.18 83.4717 196.872 82.5054 196.703 81.4824L192.963 58.8547L185.968 60.0108C184.359 60.2768 183.27 61.7972 183.536 63.4067L186.619 82.0581Z"
            fill="black"
        />
        <path
            d="M274.803 63.5264C266.346 70.1087 265.131 71.722 255.658 72.6786M259.692 69.9161L255.321 70.6386L256.044 75.0101L260.075 74.0442L259.692 69.9161Z"
            stroke="black"
            strokeWidth="1.77229"
        />
        <path
            d="M155.819 67.8957C151.29 88.4347 144.523 98.2883 124.318 105.868L119.383 101.386C138.38 93.2545 145.771 85.4135 149.456 66.3715C149.841 64.3816 152.115 63.36 153.815 64.4638L154.617 64.9848C155.583 65.6121 156.067 66.7708 155.819 67.8957Z"
            fill="#FFA726"
        />
        <path
            d="M18.3282 76.1934C25.3252 96.0278 33.2423 104.984 54.2202 110.045L58.5723 104.996C38.7259 99.2392 30.4356 92.3567 24.4586 73.9054C23.834 71.9772 21.4523 71.2403 19.8995 72.5429L19.1667 73.1577C18.2842 73.8981 17.9449 75.1071 18.3282 76.1934Z"
            fill="#FFA726"
        />
        <path
            d="M124.663 79.6148C124.856 59.1383 108.414 42.3817 87.9376 42.1878C67.4611 41.994 50.7045 58.4363 50.5106 78.9128L49.9459 138.561C49.9134 141.994 52.2932 144.994 55.6581 145.676C78.3082 150.267 93.6855 150.577 118.208 146.238C121.606 145.637 124.066 142.674 124.098 139.223L124.663 79.6148Z"
            fill="#FFA726"
        />
        <path
            d="M98.9075 88.6891C93.5791 91.9887 89.6772 93.0852 76.8129 89.7655C76.3482 89.6456 75.9305 90.0887 76.092 90.5406C80.3667 102.496 86.1323 106.432 92.6925 105.436C99.6769 103.994 100.712 99.9755 99.8332 89.1493C99.7966 88.6989 99.2917 88.4512 98.9075 88.6891Z"
            fill="black"
            stroke="black"
            strokeWidth="2.10563"
        />
        <path
            d="M96.5996 105.214C92.6279 100.297 87.6817 99.3778 80.892 101.739C83.2879 104.37 85.7834 106.012 88.5011 106.564C91.2189 107.117 93.9837 106.581 96.5996 105.214Z"
            fill="#F48FB1"
        />
        <path
            d="M73.2526 92.272C74.6051 89.4435 75.5445 88.1054 78.2758 86.7785"
            stroke="black"
            strokeWidth="2.02445"
            strokeLinecap="round"
        />
        <path
            d="M92.7085 68.2405C93.7993 72.7711 93.9824 75.5274 93.4793 80.8632"
            stroke="black"
            strokeWidth="3.72619"
            strokeLinecap="round"
        />
        <path
            d="M84.2838 68.4956C85.5193 73.0174 85.705 75.7735 85.0546 81.1183"
            stroke="black"
            strokeWidth="3.72619"
            strokeLinecap="round"
        />
        <path
            d="M49.0801 86.3886L49.1423 74.5791C49.2539 53.3901 66.5215 36.3034 87.7106 36.4151V36.4151C108.9 36.5267 125.986 53.7943 125.875 74.9833L125.812 86.7929"
            stroke="black"
            strokeWidth="2.78758"
        />
        <path
            d="M131.182 73.5085L124.77 73.4747L124.65 96.3328L131.062 96.3666C132.447 96.3736 133.577 95.2565 133.584 93.8711L133.678 76.0305C133.685 74.6453 132.568 73.5161 131.182 73.5085Z"
            fill="black"
            stroke="black"
            strokeWidth="0.557515"
        />
        <path
            d="M43.9119 75.5802L50.3234 75.6632L50.0276 98.5197L43.616 98.4367C42.2307 98.4185 41.1219 97.281 41.1399 95.8957L41.3708 78.0563C41.389 76.6713 42.5268 75.5626 43.9119 75.5802Z"
            fill="black"
            stroke="black"
            strokeWidth="0.557515"
        />
        <path
            d="M59.556 93.4333L63.7371 93.384L63.7601 95.3351L63.7864 97.565L59.8808 97.3323L59.7476 95.7337L59.556 93.4333Z"
            fill="black"
        />
        <path
            d="M49.9197 92.3345C58.864 97.0564 54.8007 96.0079 63.7601 95.3351M59.556 93.4333L63.7371 93.384L63.7864 97.565L59.8808 97.3323L59.556 93.4333Z"
            stroke="black"
            strokeWidth="1.67255"
        />
    </svg>
);

export default SessionDoneDecoration;
